<template>
	<div>
		<div style="font-size: 53px;color: #999;text-align: center;padding-top: 40px;">Freshin</div>
		<div style="font-size: 27px;color: #666;text-align: center;">Admin Login</div>
		<div style="text-align: center;">
			<a-tabs defaultActiveKey="1" size="large" style="width: 400px;display: inline-block;">
				<a-tab-pane tab="账户密码登录" key="1">
					<a-form id="login" :form="form" class="login-form" @submit="handleSubmit">
						<a-form-item>
							<a-input size="large" v-decorator="[
					          'username',
					          { rules: [{ required: true, whitespace:true, pattern: /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/, message: '请输入正确的邮箱!' }] }
					        ]"
							 placeholder="邮箱">
								<a-icon slot="prefix" type="user" style="color: rgba(0,0,0,.25)" />
							</a-input>
						</a-form-item>
						<a-form-item>
							<a-input size="large" v-decorator="[
					          'password',
					          { rules: [{ required: true, message: '请输入你的密码!' }] }
					        ]"
							 type="password" placeholder="密码">
								<a-icon slot="prefix" type="lock" style="color: rgba(0,0,0,.25)" />
							</a-input>
						</a-form-item>
						<a-form-item style="text-align: left;">
							<a-checkbox v-decorator="[
					          'remember',
					          {
					            valuePropName: 'checked',
					            initialValue: true,
					          }
					        ]">
								自动登录
							</a-checkbox>
							<a style="float: right;" @click="forgot">忘记密码?</a>
							<a-button size="large" type="primary" html-type="submit" class="login-form-button">
								登录
							</a-button>
						</a-form-item>
					</a-form>
				</a-tab-pane>
				<a-tab-pane tab="扫码登录" disabled key="2" forceRender>Content of Tab Pane 2</a-tab-pane>
			</a-tabs>

			<div style="position: absolute;bottom: 30px;text-align: center;width: 100%;font-size: 12px;">powered by Freshin</div>
		</div>
	</div>
</template>

<script>
	import CryptoJS from 'crypto-js';

	export default {

		data() {
			return {

			}
		},
		created() {
			var self = this;
			if (localStorage.getItem('username') && localStorage.getItem('password') && localStorage.getItem('twiceconfirm')) {
				this.$axios.get('/basic/login', {
					params: {
						username: localStorage.getItem('username'),
						password: localStorage.getItem('password')
					}
				}).then(function(res) {
					if (res.data.status == 0) {
						self.$message.error(res.data.error);
					}
					if (res.data.status == 1) {
						self.$message.success("登录成功");
						sessionStorage.setItem('userinfo', JSON.stringify(res.data.userinfo));
						// axios.get('/basic/sitesetting').then(function(res) {
						// 	sessionStorage.setItem('siteinfo', JSON.stringify(res.data.sitesetting));
						// });
						self.$router.push("mainpage");
					}
				});
			} else {
				localStorage.removeItem('twiceconfirm');
			}
		},
		beforeCreate() {
			this.form = this.$form.createForm(this);
		},
		methods: {
			forgot() {
				this.$router.push('forgotpassword');
			},
			handleSubmit(e) {
				var self = this;
				e.preventDefault();
				this.form.validateFields((err, values) => {
					if (!err) {
						values.password = CryptoJS.MD5(values.password).toString(CryptoJS.enc.Hex);
						if (values.remember) {
							localStorage.setItem('username', values.username);
							localStorage.setItem('password', values.password);
						} else {
							localStorage.removeItem('username');
							localStorage.removeItem('password');
							localStorage.removeItem('twiceconfirm');
						}
						self.$axios.get('/basic/login', {
							params: {
								username: values.username,
								password: values.password
							}
						}).then(function(res) {
							if (res.data.status == 0) {
								self.$message.error(res.data.error);
							}
							if (res.data.status == 1) {
								self.$router.push({
									name: 'twiceconfirm',
									params: res.data.userinfo
								});
							}
						});

					}
				});
			},
		},

	};
</script>

<style>
	#login .login-form {
		max-width: 300px;
	}

	#login .login-form-button {
		width: 100%;
	}
</style>



// WEBPACK FOOTER //
// index.vue?91dc8b30